import React, { forwardRef, memo, useState } from 'react';
import { readOnlyAction } from 'contexts/adminAccess';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { useParams } from 'react-router-dom';

import AchBalanceCheckDialog from './AchBalanceCheckDialog';

// RLPR-20420 transaction action: check the bank balance behind a pending ACH deposit
const CheckAchBalanceField = forwardRef((props: any, ref: any) => {
  const { record, hideAction } = props;

  const { id } = useParams();

  const [openDialog, setOpenDialog] = useState<boolean>(false);

  if (hideAction) {
    return null;
  }

  return (
    <>
      <Tooltip title="Refreshes the bank balance through Stripe to assess the pending ACH risk">
        <MenuItem ref={ref} onClick={() => setOpenDialog(true)}>
          Check bank balance
        </MenuItem>
      </Tooltip>

      {openDialog && (
        <AchBalanceCheckDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          userId={id}
          paymentIntent={record?.details?.paymentIntentId}
        />
      )}
    </>
  );
});

export default readOnlyAction(memo(CheckAchBalanceField), 'canReadBilling');
